import React, { Suspense } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { AuthRoute } from "./auth.routes";

const Login = React.lazy(() => import("../screens/Login"));
const Cadastro = React.lazy(() => import("../screens/Cadastro"));
const Pedidos = React.lazy(() => import("../screens/Pedidos"));
const DadosCadastrais = React.lazy(() => import("../screens/DadosCadastrais"));
const NovaProposta = React.lazy(() => import("../screens/NovaProposta"));
const PropostaFiltros = React.lazy(() => import("../screens/PropostaFiltros"));
const ResumoProposta = React.lazy(() => import("../screens/ResumoProposta"));
const Pdf = React.lazy(() => import("../screens/PDF"));
const DetalhesProposta = React.lazy(
  () => import("../screens/DetalhesProposta")
);

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<></>}>
        <Switch>
          <Route path="/login" exact component={Login} />
          <Route path="/cadastro" component={Cadastro} />

          <AuthRoute path="/pedidos" component={Pedidos} />
          <AuthRoute path="/dadoscadastrais" component={DadosCadastrais} />

          <AuthRoute path="/proposta/pdf" component={Pdf} />
          <AuthRoute path="/proposta/detalhes" component={DetalhesProposta} />
          <AuthRoute path="/proposta/resumo" component={ResumoProposta} />
          <AuthRoute path="/proposta/filtrar" component={PropostaFiltros} />
          <AuthRoute path="/proposta" component={NovaProposta} />

          <Route path="*" render={() => <Redirect to="/login" />} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routes;
